module.exports = __webpack_public_path__ + "img/couples-010.e05b9718.jpg";